import { render, staticRenderFns } from "./ChatGifV2.vue?vue&type=template&id=7fae2de8"
import script from "./ChatGifV2.vue?vue&type=script&lang=js"
export * from "./ChatGifV2.vue?vue&type=script&lang=js"
import style0 from "./ChatGifV2.vue?vue&type=style&index=0&id=7fae2de8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports